<div class="wrapper" *ngrxLet="{ isLegendVisible: isLegendVisible$ } as vm">
    <div class="risk-levels" *ngIf="vm.isLegendVisible" @slideIn>
        <dtm-ui-risk-levels></dtm-ui-risk-levels>
    </div>
    <button class="button-tertiary" type="button" (click)="changeLegendVisibility()">
        {{ "dtmMapCesium.riskLegend.toggleButtonValueLabel" | transloco : { value: vm.isLegendVisible } }}
        <dtm-ui-icon [name]="vm.isLegendVisible ? 'arrow-up' : 'arrow-down'"></dtm-ui-icon>
    </button>
</div>
